import { consoleEvents } from '@pb/utils'

import { CheckoutSuccessAction } from 'features/checkout/constants'
import { postProceedFail } from 'features/checkout/duck/actions'
import { handleProceedError } from 'features/checkout/duck/operations/postProceed/handleProceedError'
import checkoutSelectors from 'features/checkout/duck/selectors'
import { postConfirmCheckout } from 'features/checkout/requests'
import { completeCybersourceCheckout } from 'features/cybersource/duck/actions'
import { operationProcessCybersourceCheckoutResponse } from 'features/cybersource/duck/operations'
import { ThunkResult } from 'redux/types'

export const operationConfirmCybersourceCheckout =
  ({ ...cybersourceData }): ThunkResult<Promise<void>> =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const { firstName, lastName } = checkoutSelectors.getCybersourceCreditCardValues(state)
      const confirmResponse = await postConfirmCheckout({
        cybersourceData,
        firstName,
        lastName,
      })

      if (confirmResponse.successAction === CheckoutSuccessAction.CybersourceStepUpIframe) {
        dispatch(operationProcessCybersourceCheckoutResponse(confirmResponse))
      } else if (confirmResponse.successAction === CheckoutSuccessAction.SelfRedirect) {
        window.location.href = confirmResponse.redirectURL
      }
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(completeCybersourceCheckout())
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }

export const operationAbortConfirmCybersourceCheckout =
  (): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
      dispatch(completeCybersourceCheckout())
      await postConfirmCheckout({
        abortPayment: true,
      })
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }
